import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { AtaReuniaoForm } from "../../modais"

class AtaReuniaoEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/atareuniao")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <AtaReuniaoForm isEditing={true} callBackAtaReuniao={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(AtaReuniaoEditForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/ata-reuniao/AtaReuniaoEditForm.js